import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import BlogTwo from "../../Blogdetails/BlogTwo";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom
          title="Home"
          subtitle="Why Practical Training Matters More Than Ever in Pharmacy Education"
        />
        <BlogTwo />
      </section>
    </>
  );
}

export default Main;
